import { Col, Container, Row } from "react-bootstrap";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewIntegrationMutation } from "../../../services/bClientApi";
import IntegrationForm from "../../../Components/Forms/IntegrationForm/IntegrationForm";

export default function AddIntegrationPage() {

    const [
        addNewIntegration,
        {
            isLoading,
            error
        }
    ] = useAddNewIntegrationMutation()

    const dispatch = useAppDispatch()

    const handleSubmit = async (data: any) => {
        const values: any = { ...data }
        if (values.externalIds && typeof values.externalIds === 'string') {
            try { values.externalIds = JSON.parse(values.externalIds) } catch { values.externalIds = {} }
        }
        if (values.overrideData && typeof values.overrideData === 'string') {
            try { values.overrideData = JSON.parse(values.overrideData) } catch { values.overrideData = null }
        }
        const newIntegration = await addNewIntegration(values).unwrap()
        if (newIntegration._id) {
            dispatch(navigateTo(`/integration/${newIntegration._id}`))
        }
        return newIntegration
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Add Integration</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <IntegrationForm
                        initialData={{
                            entityType: '',
                            entityId: '',
                            provider: '',
                            primaryExternalId: '',
                            externalIds: '',
                            overrideData: '',
                            sync: {
                                status: '',
                            }
                        }}
                        disabled={isLoading}
                        onSubmit={handleSubmit}
                    />
                </Col>
            </Row>
        </Container>
    )
}
